import React from "react";
import styled from "styled-components";
import { TextField, Typography, Flex } from "../../../components";

interface NameFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const NameField: React.FC<NameFieldProps> = ({ value, onChange }) => {
  return (
    <Flex direction="column" gap="xs">
      <Typography variant="caption" colorScheme="muted" as="span">Name</Typography>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter your full name"
        fullWidth
        
      />
    </Flex>
  );
};